import { BiteLogSquareEvent } from './bite_log_square_event.js';

export function name(event: BiteLogSquareEvent): string {
  switch (event) {
    case BiteLogSquareEvent.None:
      return 'ok';
    case BiteLogSquareEvent.AuthorizationSuccess:
      return 'authorization-success';
    case BiteLogSquareEvent.AuthorizationError:
      return 'authorization-error';
    case BiteLogSquareEvent.ReaderSettingsSuccess:
      return 'reader-settings-success';
    case BiteLogSquareEvent.ReaderSettingsError:
      return 'reader-settings-error';
    case BiteLogSquareEvent.CheckoutErrorDeprecated:
      return 'checkout-error-deprecated';
    case BiteLogSquareEvent.ReaderDisconnected:
      return 'reader-disconnected';
    case BiteLogSquareEvent.CheckoutCancelled:
      return 'checkout-cancelled';
    case BiteLogSquareEvent.CheckoutErrNotAuthorized:
      return 'checkout-err-not-authorized';
    case BiteLogSquareEvent.CheckoutErrUsageError:
      return 'checkout-err-usage';
    case BiteLogSquareEvent.CheckoutTimeout:
      return 'checkout-timeout';
    case BiteLogSquareEvent.CheckoutNoNetwork:
      return 'checkout-no-network';
    case BiteLogSquareEvent.CheckoutLocationServicesDisabled:
      return 'checkout-checkout-location-services-disabled';
    case BiteLogSquareEvent.PairingSuccess:
      return 'pairing-success';
    case BiteLogSquareEvent.PairingError:
      return 'pairing-error';
  }
}
